export const INTRODUCTION_IS_SHOWN = 'INTRODUCTION_IS_SHOWN';

export const introductionIsShown = () => ({
  type: INTRODUCTION_IS_SHOWN
});